import { render, staticRenderFns } from "./ComunicationBar.vue?vue&type=template&id=7ef5d8aa"
import script from "./ComunicationBar.vue?vue&type=script&lang=js"
export * from "./ComunicationBar.vue?vue&type=script&lang=js"
import style0 from "./ComunicationBar.vue?vue&type=style&index=0&id=7ef5d8aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports